import React from 'react';
import { connect } from "react-redux";
import ProviderList from './List.js'
import CreateProvider from './Create'
import { withNamespaces } from 'react-i18next';
import CreateButton from './../../../Global/CreateButton'
import { Col, Row, Form } from 'react-bootstrap';

export class Main extends React.Component{
	constructor(props) {
		super(props);
        
		this.state={
            postavkeStupaca: null
		} 
	}

    toggleCreate = async () => {
        await this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        //this.componentDidMount()
    }

    render(){ 
        const { t } = this.props 
      
        return(
            <main className="scrollbar-hidden">  
                {this.state.create ? 
                    <CreateProvider goBack={() => this.backFromCreate()} />
                :  
                <>    
                    <header>
                        <Row>
                           <Form.Group as={Row} className="mb-3">   
                                <Col sm={12} xl={12}>
                                    <h2>
                                        {t('Providers')}
                                    </h2>  
                                    <hr/>
                                </Col>
                                <CreateButton style={{padding: "0px"}}toggleCreate={this.toggleCreate}/>
                            </Form.Group>
                        </Row>
                    </header>  

                    <ProviderList 
                        postavkeStupaca={this.state.postavkeStupaca} 
                        toggleCreate={this.toggleCreate}
                    />
                </>
            }
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
        credentials: state.user.credentials
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(Main));
